import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IContentVersionSummary } from 'src/app/core/dtos/interfaces/i-content-version-summary';
import { Content } from 'src/app/core/models/i-content';
import { ContentStatus } from 'src/app/shared/enums/content-status';
import { ContentTypeRouterPaths } from 'src/app/shared/enums/content-type-router-paths';
import { ContentTypes } from 'src/app/shared/enums/content-types';

@Component({
  selector: 'app-version-list',
  templateUrl: './version-list.component.html',
  styleUrls: ['./version-list.component.scss'],
})
export class VersionListComponent {
  @Input() versions: IContentVersionSummary[];
  @Input() articleId: string;
  @Input() repurposedFromArticleId?: string;
  @Input() latestPublishedVersionId: string;
  @Input() latestVersionId: string;
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
  @Input() contentType: `${ContentTypes}`;

  /**
   *
   */
  constructor(private _router: Router) {}
  contentTypeUrl: string = '';

  ngOnInit(): void {
    this.sortVersionList();

    this.contentTypeUrl =
      ContentTypeRouterPaths[<ContentTypes>this.contentType.toLowerCase()];
  }

  getCssClasses(versionId: string, isVersionSpiked: boolean): string[] {
    this.sortVersionList();
    if (versionId === this.articleId && !isVersionSpiked) {
      return [
        'font-semibold',
        'bg-project-50',
        'border-project-2100',
        'bg-opacity-30',
        'border',
      ];
    }
    if (isVersionSpiked) {
      return [
        'hover:bg-project-2100',
        'hover:border-project-2100',
        'bg-opacity-30',
        'bg-project-3400',
        'border-project-2700',
        'border',
      ];
    }
    if (versionId === this.latestPublishedVersionId) {
      return [
        'hover:bg-project-2100',
        'hover:border-project-2100',
        'bg-project-3000',
        'border-project-3300',
        'border',
      ];
    }
    if (versionId === this.latestVersionId) {
      return [
        'hover:bg-project-2100',
        'hover:border-project-2100',
        'bg-opacity-30',
        'bg-project-1000',
        'border-project-1000',
        'border',
      ];
    }

    return ['hover:bg-project-2100'];
  }

  redirect(version: IContentVersionSummary) {
    this._router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this._router.navigate([
          '/content',
          this.contentTypeUrl,
          version.id,
          'edit',
        ]),
      );
  }

  isSpikedOrPublished(version: IContentVersionSummary) {
    return (
      version.status === ContentStatus.SPIKED ||
      version.status === ContentStatus.PUBLISHED
    );
  }

  sortVersionList() {
    this.versions = this.versions.sort((a, b) =>
      a.createdDate < b.createdDate ? 1 : -1,
    );
  }

  getDisplayStatus(isSpiked: boolean): string {
    return isSpiked ? ContentStatus.SPIKED : ContentStatus.PUBLISHED;
  }
}
